var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.item.stopTime)?_c('span',{staticClass:"blink_me"},[_vm._v(_vm._s(_vm._f("formatTime")(_vm.clock)))]):_c('span',[_vm._v(_vm._s(_vm._f("formatTimeRoundupSecond")(_vm.calculateTime(_vm.item))))])
}
var staticRenderFns = []

export { render, staticRenderFns }